module.exports = __webpack_public_path__ + "static/plan-reboot-policy-pipeline-c9b28bed83c87c5fd8154560063ba3e7.png";